/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Soft_Skills_Too_FewInputs */

const en_validation_soft_skills_too_few = /** @type {(inputs: Validation_Soft_Skills_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select at least one soft skill.`)
};

const de_validation_soft_skills_too_few = /** @type {(inputs: Validation_Soft_Skills_Too_FewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte mindestens eine Soft Skill auswählen.`)
};

/**
* | output |
* | --- |
* | "Please select at least one soft skill." |
*
* @param {Validation_Soft_Skills_Too_FewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_soft_skills_too_few = /** @type {((inputs?: Validation_Soft_Skills_Too_FewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Soft_Skills_Too_FewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_soft_skills_too_few(inputs)
	return en_validation_soft_skills_too_few(inputs)
});